export const comsText1Template = (
  node: HTMLElement,
) => `<em>${node.innerHTML}</em>`;

export const comsText2Template = (
  node: HTMLElement,
) => `<strong><em>${node.innerHTML}</em></strong>`;

export const comsText3Template = (
  node: HTMLElement,
) => `<one-text spaced>${node.innerHTML}</one-text>`;
